import React from 'react'
import PropTypes from 'prop-types'
import { Truck as TruckIcon, Box as BoxIcon } from '@walmart-web/livingdesign-icons'
import texts from '../../../../common/texts.json'

import './index.css'

const WfsDisclaimerBody = ({ seller }) => {
  return (
    <div className="wfs-disclaimer-content">
      <div className="wfs-disclaimer-content__title-container">
        <p>
          {texts.COMMON.SOLD_BY}{' '}
          <b>
            {seller}, {texts.COMMON.DELIVERED_BY_WALMART_LABEL}
          </b>
        </p>
      </div>

      <div className="wfs-disclaimer-content__body-container d-flex mb-2">
        <div className="wfs-disclaimer-content__body-container__icon ml-2 mr-2">
          <BoxIcon width={23} height={22} />
        </div>
        <div className="wfs-disclaimer-content__body-container__message">
          <p className="d-flex m-0">{texts.PRODUCT_DETAIL.WFS_DISCLAIMER.PROGRAM_DESCRIPTION}</p>
        </div>
      </div>

      <div className="wfs-disclaimer-content__body-container d-flex mb-4">
        <div className="wfs-disclaimer-content__body-container__icon ml-2 mr-2">
          <TruckIcon width={23} height={22} />
        </div>
        <div className="wfs-disclaimer-content__body-container__message">
          <p className="d-flex m-0">{texts.PRODUCT_DETAIL.WFS_DISCLAIMER.FASTER_DELIVERY}</p>
        </div>
      </div>
    </div>
  )
}

WfsDisclaimerBody.propTypes = {
  seller: PropTypes.string.isRequired,
}

export default WfsDisclaimerBody
